import { MetaApprovalStatusDefinition, WhatsAppContentDefinition } from 'modules/graphql/types';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { InfoBanner } from 'ui/banner';
import { Link } from 'ui/links';
import { colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { useEditableFieldsContext } from '../context/EditableFieldsContext';
import {
  WHATS_APP_CREATING_TEMPLATE_SUPPORT_DOCS_LINK,
  WHATS_APP_NEW_TEMPLATE_GUIDELINES_LINK,
} from './constants';

/** Matches the max width of the template editor header content */
const MAX_WIDTH = pxToRem(1842);

const Container = styled.div`
  display: flex;
  justify-content: center; 
  margin-top: ${spacing.plusHalf};
  
  > div {
    max-width: ${MAX_WIDTH};
    width: 100%;
  }
`;

const StyledLink = styled(({ ...props }) => <Link target="_blank" variant="inherit" {...props} />)`
  text-decoration-color: ${colors.borderInfoSubtle};
  text-decoration-skip-ink: auto;
`;

export const WhatsAppInfoBanner = () => {
  const { initialTemplate } = useEditableFieldsContext();
  const whatsAppData = (initialTemplate?.mediumData || {}) as WhatsAppContentDefinition;
  const { metaApprovalStatus, previousCategory } = whatsAppData;
  /** @ts-ignore `whatsAppCategory` is used for rendering the load state, whereas `category` is actually present on WhatsAppContentDefinition but is used for update mutation. */
  const whatsAppCategory = whatsAppData?.whatsAppCategory as WhatsAppContentDefinition['category'];

  const [isVisible, setIsVisible] = useState(false);

  const handleClose = () => {
    setIsVisible(false);
  };

  useEffect(() => {
    if (previousCategory && metaApprovalStatus === MetaApprovalStatusDefinition.Approved)
      setIsVisible(true);
  }, [previousCategory, metaApprovalStatus]);

  if (!isVisible) return null;

  return (
    <Container data-test="whats-app-info-banner">
      <InfoBanner
        BannerActions={
          <StyledLink href={WHATS_APP_CREATING_TEMPLATE_SUPPORT_DOCS_LINK} hasOpenNewTabIcon>
            Learn more
          </StyledLink>
        }
        onClose={handleClose}
      >
        This template was approved by Meta but automatically re-categorized from{' '}
        <strong>{previousCategory}</strong> to <strong>{whatsAppCategory}</strong> based on its
        content. If you intended to send a <strong>{previousCategory}</strong> message, review{' '}
        <StyledLink href={WHATS_APP_NEW_TEMPLATE_GUIDELINES_LINK}>Meta's guidelines</StyledLink>,
        create a new template with compliant content, and try again.
      </InfoBanner>
    </Container>
  );
};
